import DivisiService from "../../services/datamaster/divisi.service";

export const Divisi = {
    data() {
      return {
        optionMasterDivisi : [],
        multi_master_divisi : [],
        items_master_divisi : [],
      };
    },
    methods: {
      getAllDivisi() {
        DivisiService.getDivisi(0,10000,"default")
          .then(response => {
              this.optionMasterDivisi = response.data.data.content
              this.items_master_divisi = response.data.data.content 
          }).catch(error => {
              // comment console console.log(error)
          })
      }
    }
  };